var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulgaria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "85.5 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.048223
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    width: 24,
    height: 17,
    fill: "#00966e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    width: 24,
    height: 5.6667,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 11.333,
    width: 24,
    height: 5.6667,
    fill: "#d62612"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulgaria);
export default __webpack_public_path__ + "static/media/bulgaria.76fcbef7000a8791f450b9f8174d4018.svg";
export { ForwardRef as ReactComponent };